import { Property } from "csstype"
import { Theme } from "../../../../modules/design/Theme"
import { Intent } from "../../../../modules/intent/Intent"
import { getBackgroundColorForIntent } from "../../../../modules/intent/getBackgroundColorForIntent"
import { getForegroundColorForIntent } from "../../../../modules/intent/getForegroundColorForIntent"
import { CSSObject } from "../../css/CSSObject"

type Params = {
  disabled?: boolean
  float?: Property.Float
  intent: Intent
  paddingBottom?: number
  paddingLeft?: number
  paddingRight?: number
  paddingTop?: number
  theme: Theme
  useAltShade?: boolean
}

export const buttonCSS = ({
  disabled,
  float,
  intent,
  paddingBottom,
  paddingLeft,
  paddingRight,
  paddingTop,
  theme,
  useAltShade = false
}: Params): CSSObject => {
  const { colors, fonts } = theme

  return {
    backgroundColor: getBackgroundColorForIntent(intent, useAltShade, false, colors),
    borderStyle: "none",
    color: getForegroundColorForIntent(intent, useAltShade, colors),
    cursor: disabled ? "not-allowed" : "pointer",
    float,
    fontFamily: fonts.lato.name,
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    outline: "none",
    paddingBottom: paddingBottom ?? 5,
    paddingLeft: paddingLeft ?? 25,
    paddingRight: paddingRight ?? 25,
    paddingTop: paddingTop ?? 5,
    "&:hover": {
      backgroundColor: getBackgroundColorForIntent(intent, useAltShade, true, colors)
    }
  }
}
